import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  TableBody,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Paginator from "../../../toolkit/Paginator";
import Stack from "@mui/material/Stack";
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import BaseUrl from "../../../utils/base-uri.json";
import { isArray } from "lodash";
import _ from "lodash";
import fvAxios from "../../../utils/fvAxios";
import { FormatToLocalSystemDateTime } from "../../../utils/dateFormat";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import Delayed from "../../../utils/Delayed";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import { KeyboardArrowDown, KeyboardArrowUp, UnfoldMore } from "@mui/icons-material";
import debounce from 'lodash/debounce';

const queryUrl = BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.SineproData;
const pageSize = 10;

const toQueryString = (obj) => {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
};

const getUrl = (url, data) => `${url}${toQueryString(data)}`;

const toastNotify = (message, isSuccess = true) => {
  if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

const headers = [
  { label: "VisitorName", key: "visitorName" },
  { label: "Last Checkin", key: "checkin" },
  { label: "Company Name", key: "companyName" },
  { label: "Site Name", key: "siteName" },
  { label: "Security Name Checkin", key: "checkinUser" },
];

const convertToCSV = (data) => {
  const header = headers.map((header) => `"${header.label}"`).join(",");
  const rows = data.map((item) =>
    headers
      .map((header) => {
        if (header.key === "checkin") {
          return GetfVDateFormate(item[header.key]);
        }
        return `"${item[header.key]}"`;
      })
      .join(",")
  );
  return [header, ...rows].join("\n");
};

export default function Sinepro() {
  const { t } = useTranslation();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
      marginBottom: "20px",
    },
  }));

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };

  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [Searchdebounce, setSearchdebounce] = useState("");
  const [visitors, setVisitors] = useState([]);
  const [isDownload, setIsDownload] = useState(true);
  const [sites, setSites] = useState([]);
  const [siteId, setSiteId] = useState(-1);
  const [loading, setLoading] = useState(false);

  const [orderBy, setOrderBy] = useState({
    sortingColumn: "VisitorName",
    sortAscending: true,
  });

  const [paramsState, setParamsState] = useState({
    freeText: searchValue,
    siteId: siteId,
    orderBy: orderBy.sortingColumn,
    sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
    pageSize: 10,
    pageNumber: pageNumber,
  });

  const sortTable = (sortingColumn) => {
    if (orderBy.sortingColumn === sortingColumn) {
      setOrderBy((prev) => ({
        ...prev,
        sortAscending: !orderBy.sortAscending,
      }));
    } else {
      setOrderBy({
        sortingColumn,
        sortAscending: true,
      });
    }
  };

  const setPage = (pageNumber) => {
    if (pageNumber > 0) {
      setPageNumber(pageNumber);
      setParamsState((prev) => ({ ...prev, pageNumber }));
      setRefresh(true);
    }
  };

  useEffect(() => {
    setParamsState((prev) => ({
      ...prev,
      orderBy: orderBy.sortingColumn,
      sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
    }));
    setRefresh(true);
  }, [orderBy]);

  useEffect(() => {
    if (refresh) {
      setLoading(true);
      if (searchValue === Searchdebounce) {
        const url = getUrl(queryUrl, { ...paramsState });
        fvAxios
          .get(url)
          .then((res) => {
            if (res?.data?.status === true) {
              // if (!isDownload) {
              setPageCount(
                Math.ceil((res?.data?.count || pageSize) / pageSize)
              );
              setVisitors(res?.data?.data);
              // } else {
              //   if (res?.data?.data) {
              //     const csvContent = convertToCSV(res?.data?.data);
              //     const blob = new Blob([csvContent], { type: "text/csv" });
              //     const url = URL.createObjectURL(blob);
              //     const a = document.createElement("a");
              //     a.href = url;
              //     a.download = "Sine Pro Checkin.csv";
              //     a.click();
              //     URL.revokeObjectURL(url);
              //   }
              //   setIsDownload(false);
              // }
            } else {
              toastNotify(res?.data?.responseMessage, false);
            }
          })
          .catch((err) => setError(err))
          .finally(() => {
            setRefresh(false);
            setLoading(false);
          });
      }
    }
  }, [refresh, searchValue, Searchdebounce]);


  useEffect(() => {
    fvAxios
      .get(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.SineproSites)
      .then((response) => {
        setSites(response?.data?.data);
      });
  }, []);

  const changeSite = (value) => {
    setSiteId(value);
    setParamsState({ ...paramsState, siteId: value, pageNumber: 1 });
    setRefresh(true);
  };

  // const debouncedSearch = _.debounce((value) => {
  //   setParamsState((prev) => ({
  //     ...prev,
  //     freeText: value,
  //     pageNumber: 1,
  //   }));
  //   setRefresh(true);
  // }, 1000);

  // const changeSearchValue = (value) => {
  //   if (searchValue !== value) {
  //     setSearchValue(value);
  //     debouncedSearch(value);
  //   }
  // };

  const delayedSearch = debounce((value) => {
    setSearchdebounce(value)
    setParamsState((prev) => ({
      ...prev,
      search: value,
      pageNumber: 1,
    }));
    setRefresh(true);
  }, 2000);

  const changeSearchValue = (e) => {
    const { value } = e.target;
    setSearchValue(value);
    delayedSearch(value);
  };

  const handleDownload = () => {
    // setIsDownload(true);
    // setParamsState({ ...paramsState, isDownload: true, pageNumber: 1 });
    // setRefresh(true);

    const url = getUrl(queryUrl, { ...paramsState, isDownload: true });
    fvAxios
      .get(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const csvContent = convertToCSV(res?.data?.data);
          const blob = new Blob([csvContent], { type: "text/csv" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Sine Pro Checkin.csv";
          a.click();
          URL.revokeObjectURL(url);
        } else {
          toastNotify(res?.data?.responseMessage, false);
        }

      });

    // const csvContent = convertToCSV(visitors);
    // const blob = new Blob([csvContent], { type: "text/csv" });
    // const url = URL.createObjectURL(blob);
    // const a = document.createElement("a");
    // a.href = url;
    // a.download = "Sine Pro Checkin.csv";
    // a.click();
    // URL.revokeObjectURL(url);
  };

  return (
    <>
      <ToastContainer />
      <Card>
        <Divider
          sx={{
            marginTop: 2,
            marginBottom: 2,
            backgroundColor: "#667085;",
            height: "2px",
          }}
        />
        <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
          <Stack spacing={2} direction="row">
            <TextField
              placeholder="Search"
              value={searchValue}
              onChange={changeSearchValue}
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
              }}
              variant="outlined"
              size="small"
            />
            <div style={{ marginLeft: "Auto" }}>
              <FormControl sx={{ m: 1, width: 200 }}>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  value={siteId}
                  size="small"
                  onChange={(e) => changeSite(e.target.value)}
                  MenuProps={MenuProps}
                >
                  <MenuItem key={-1} value={-1}>
                    All Sites
                  </MenuItem>
                  {sites &&
                    sites.map((s) => (
                      <MenuItem key={s?.value} title={s.text} value={s?.value}>
                        {s?.text}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <Box sx={{ display: "flex" }}>
                {/* {visitors?.length > 0  ? */}
                <Button
                  className="mx-2"
                  variant="contained"
                  onClick={handleDownload}
                  style={{
                    cursor: "pointer",
                    textTransform:"capitalize",
                    padding: "10px"
                  }}
                >
                  <span className="mx-1">{t("Dashboard.download")}</span>
                </Button>

                {/* <Button

                  style={{
                    width: "90px",
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "#101828",
                    borderStyle: "solid",
                    borderColor: "#E4E7EC",
                    borderRadius: "4px",
                    marginRight: "5px",
                    marginLeft: "10px",
                  }}
                >
                  <span className="mx-1">{t("Dashboard.download")}</span>
                </Button> */}
                {/* : <CircularProgress />} */}
              </Box>
            </div>
          </Stack>
        </div>
        <Box sx={{ backgroundColor: "#f8f9fa" }}>
          {loading ? (
            <LoadingSpinner />
          ) : visitors?.length > 0 ? (
            <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      onClick={() => sortTable("VisitorName")}
                    >
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Visitor Name
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "VisitorName" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell
                      onClick={() => sortTable("Checkin")}
                    >
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Last Checkin
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "Checkin" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell
                      onClick={() => sortTable("CompanyName")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Company Name
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "CompanyName" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell
                      onClick={() => sortTable("SiteName")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Site Name
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "SiteName" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell
                      onClick={() => sortTable("CheckinUser")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Security Name Checkin
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "CheckinUser" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                {visitors?.map((r, i) => (
                  <TableBody key={i}>
                    <TableRow key={i}>
                      <StyledTableCell sx={{ width: "20%" }}>
                        {r.visitorName}
                      </StyledTableCell>
                      <StyledTableCell sx={{ width: "20%" }}>
                        {GetfVDateFormate("", "", r.checkin)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ width: "20%" }}>
                        {r.companyName}
                      </StyledTableCell>
                      <StyledTableCell sx={{ width: "20%" }}>
                        {r.siteName}
                      </StyledTableCell>
                      <StyledTableCell sx={{ width: "20%" }}>
                        {r.checkinUser}
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                ))}
              </Table>
            </TableContainer>
          ) : error ? (
            <ErrorAlert message={error} />
          ) : (
            <ErrorAlert severity="warning" message={"No results found!"} />
          )}
        </Box>
      </Card>
      {visitors?.length > 0 && (
        <Paginator
          count={pageCount}
          page={Number(pageNumber)}
          margin="18px 0px"
          onChange={setPage}
        />
      )}
    </>
  );
}
